import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Articles from "./pages/Articles";
import ArticleDetail from "./pages/ArticleDetail";
import Repositories from "./pages/Repositories";
import RepositoryDetail from "./pages/RepositoryDetail";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import About from "./pages/About";
import Bookmarks from "./pages/Bookmarks";
import Newsletter from "./pages/Newsletter";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Profile from "./pages/Profile";
import Unsubscribe from "./pages/Unsubscribe";
import Videos from "./pages/Videos";
import AuthCallback from "./pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Google OAuth callback: session_id arrives in URL fragment — must be handled first
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/articles" element={<Articles />} />
      <Route path="/articles/:slug" element={<ArticleDetail />} />
      <Route path="/repositories" element={<Repositories />} />
      <Route path="/repositories/:id" element={<RepositoryDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/about" element={<About />} />
      <Route path="/bookmarks" element={<Bookmarks />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/newsletter" element={<Newsletter />} />
      <Route path="/unsubscribe" element={<Unsubscribe />} />
      <Route path="/videos" element={<Videos />} />
      <Route path="/videos/:id" element={<Videos />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Nav />
        <main className="flex-1 relative z-10">
          <AppRouter />
        </main>
        <Footer />
      </div>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#12121C",
            border: "1px solid rgba(0, 240, 255, 0.3)",
            color: "#F3F4F6",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
